import { ContentLoader } from '@/components/ui/loaders';
import { Toaster } from '@/components/ui/sonner';
import { Suspense } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
export function AppProvider({ children }: { children: React.ReactNode }) {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Enchei-vos — Retiro de Casais</title>
        <meta
          http-equiv="Content-Security-Policy"
          content="default-src * 'unsafe-inline' 'unsafe-eval' data: blob:;"
        />
      </Helmet>
      <Toaster position="bottom-right" duration={2400} />
      <Suspense fallback={<ContentLoader show />}>{children}</Suspense>
    </HelmetProvider>
  );
}
